/**
 *
 * NewTreatmentHeader
 *
 */

import * as PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";
import ForegroundBlobFakeModalHeader from "../../basicComponents/ForegroundBlobFakeModalHeader/ForegroundBlobFakeModalHeader";
import messages from "containers/NewTreatmentPage/messages";
import { FormattedMessage } from "react-intl";
import { makeSelectEditingTreatment } from "../NewTreatmentPage/selectors";

function NewTreatmentHeader(props) {
  return (
    <ForegroundBlobFakeModalHeader
      enableLargePadding={props.enableLargePadding}
      onClose={props.onClose}
    >
      {props.editingTreatment ? (
        <FormattedMessage {...props.editingMessage} />
      ) : (
        <FormattedMessage {...props.newMessage} />
      )}
    </ForegroundBlobFakeModalHeader>
  );
}

NewTreatmentHeader.propTypes = {
  dispatch: PropTypes.func.isRequired,
  editingTreatment: PropTypes.bool.isRequired,
  enableLargePadding: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  editingMessage: PropTypes.object,
  newMessage: PropTypes.object,
};

NewTreatmentHeader.defaultProps = {
  enableLargePadding: false,
  editingMessage: messages.firstHeaderEditing,
  newMessage: messages.firstHeader,
};

const mapStateToProps = createStructuredSelector({
  editingTreatment: makeSelectEditingTreatment(),
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect)(NewTreatmentHeader);
